import { TStationTimingSourceEntity } from "../models";

/**
 * Editor a measured-times request is made from. The backend gates Read permission on it, so each
 * flow names its own source rather than the request being assembled from whatever screen is open.
 */
export const STATION_TIMING_SOURCE_COURSE: TStationTimingSourceEntity =
  "course";
export const STATION_TIMING_SOURCE_RIDE: TStationTimingSourceEntity = "ride";
export const STATION_TIMING_SOURCE_STATION_ROUTE: TStationTimingSourceEntity =
  "stationRoute";

/** Only rides departing within an hour of this one are comparable — traffic changes fast. */
export const STATION_TIMING_RIDE_COMPARABLE_HOURS_SPREAD = 1;
